import { HIDE_ASIDE_MENU, TOGGLE_ASIDE_MENU } from "app/actionTypes";

export default (
	state = {
		isAsideMenuOpened: false,
	},
	action
) => {
	switch (action.type) {
		case TOGGLE_ASIDE_MENU:
			return Object.assign({}, state, {
				isAsideMenuOpened: !state.isAsideMenuOpened,
			});
		case HIDE_ASIDE_MENU:
			return Object.assign({}, state, {
				isAsideMenuOpened: false,
			});
		default:
			return state;
	}
};
